import styled from 'styled-components';

import { Col } from '@components/formStyles';
import Button from '@components/Button/next';

export const TourCardContainer = styled.div`
  width: 100%;
  min-height: 363px;
  height: auto;
  padding: 40px 40px 40px 40px;
  border-radius: 8px;
  border: solid 0px ${({ theme }) => theme.palette.gray87};
  box-shadow: 0 10px 20px 0 ${({ theme }) => theme.palette.veryLightBlack};
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 9;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 15px 15px 20px;
  }
`;
export const Wrapper = styled.div`
  width: 100%;
  height: auto;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-right: 20px;
  }
`;

export const SpacingRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TitleBorder = styled.div`
  height: 36px;
  width: 6px;
  margin: 1px 14px 6px 0;
  background-color: ${({ theme }) => theme.palette.coral};
  border-radius: 100px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 6px;
    height: 25px;
    margin: 0 11px 0 0;
  }
`;
export const Title = styled.h1`
  line-height: 38px;
  height: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-top: -3px;
    height: auto;
    line-height: normal;
  }
`;

export const Date = styled.span`
  padding-left: 20px;
  letter-spacing: 0.5px;
  display: inline-block;
  margin: 0 0 10px 3px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-left: -2px;
    margin-top: 5px;
    margin-bottom: 22px;
  }
`;
export const DetailSegments = styled.div`
  margin-right: 8px;
  margin-bottom: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-bottom: 0px;
  }
`;
export const DateDiv = styled.div``;

export const Comment = styled.span`
  font-size: 16.2px;
  font-weight: 600;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    font-size: 12px;
  }
`;

export const CommentNumber = styled.span`
  font-size: 13.5px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    font-size: 10px;
  }
`;

export const Point = styled.div`
  width: 30px;
  height: 40px;
  background-color: ${(p) => p.theme.palette.validGreen};
  align-items: center;
  display: flex;
  justify-content: center;
  color: white;
  text-align: center;
  font-size: 16.2px;
  font-weight: 600;
  margin-left: 15px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    font-size: 12px;
    width: 22px;
    height: 30px;
    margin: 0 0 0 5px;
  }
`;

export const Location = styled.span<{ isBold?: boolean }>`
  line-height: 22px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    -webkit-line-clamp: 5;
  }
  ${({ isBold }) => isBold && `font-weight: 900`}
`;

export const RightCol = styled.div`
  display: flex;
  justify-content: flex-end;
  width: auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    font-size: 20px;
  }
`;

export const RightWrapper = styled(Col)`
  display: flex;
  justify-content: space-between;
  padding-left: 40px;
  border-left: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
`;

export const CampaignLabelWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 136px;
  height: 47px;
  align-self: end;
  margin-bottom: 5px;
`;

export const DiscountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledButton = styled(Button)`
  && {
    width: 220px;
    font-size: 18px;
    height: 58px;
    font-weight: bold;
    border-radius: 8px;
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }
`;

export const ReadMore = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const PriceDetails = styled.span<{ isBold?: boolean; isTiny?: boolean }>`
  opacity: 0.75;
  font-size: ${({ isTiny }) => (isTiny ? '12px' : '14px')};
  text-align: right;
  color: ${({ theme }) => theme.palette.darkGrey};
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
`;

export const FlexEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;

export const EarliestDepartureDate = styled.span`
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const TourIntroduction = styled.div`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.PHONE})`} {
    margin-right: 89px;
  }

  & {
    font-size: 16px;
    color: ${({ theme }) => theme.palette.darkGrey};
    line-height: 1.5;
  }
`;
export const ShortInfoWrapper = styled.div`
  width: 100%;
  height: 20px;
  margin-top: 10px;
`;
export const DescriptionWrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: 10px;
  font-size: 16px;
  line-height: 1.5;
  min-height: 72px;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.45, 0.45, 0.48, 0.93);
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    max-height: auto;
  }
`;
export const Degree = styled.div`
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  z-index: 99;
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.53) 50%,
    rgba(255, 255, 255, 0.83) 82%,
    #fff 100%
  );

  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.53) 50%,
    rgba(255, 255, 255, 0.83) 82%,
    #fff 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.53) 50%,
    rgba(255, 255, 255, 0.83) 82%,
    #fff 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.53) 50%,
    rgba(255, 255, 255, 0.83) 82%,
    white 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.53) 50%,
    rgba(253, 255, 255, 0.83) 82%,
    #fff 100%
  );
`;
export const ReadMoreEmptySection = styled.span`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
export const IconContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: start;
`;
